import { Component, ContentChildren, QueryList } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardFilterCardComponent } from '../dashboard-filter-card/dashboard-filter-card.component';

@Component({
  selector: 'app-dashboard-cards',
  imports: [CommonModule],
  standalone: true,
  providers: [],
  templateUrl: './dashboard-cards.component.html',
  styleUrl: './dashboard-cards.component.scss',
})
export class DashboardCardsComponent {
  @ContentChildren(DashboardFilterCardComponent) filterCards!: QueryList<DashboardFilterCardComponent>;  
}
